export default __webpack_public_path__ + "static/media/about-1.e32a7109.png";